export const ru = {
    'other-sign': 'и ещё {number}',
    'page-name': 'Запрещённые площадки'
};
